import React, { useState, useEffect } from 'react';
import Product from './Product';
import HomeNews from './HomeNews';
import Clproduct from './Clproduct';
import CategoriesProduct from './CategorieProduct';
import Grafik from './Grafik';
import NavbarTop from './NavbarTop';
import NavbarBottom from './NavbarBottom';
import Gallery from './Gallery';
import GalleryVideo from './GalleryVideo';
import PopupImage from './PopupImage';
import Tautan from './Tautan';
import Agenda from './Agenda';
import Ebooklist from './Ebooklist';
import Bidang from './Bidang';
import LinkTerkait from './LinkTerkait';
import Info from './Info';


function Home() {

    const [openModal, SetOpenModal] = useState(1);
     const [newsList, SetNews] = useState([]);

    const modalSetClose = () => {
        SetOpenModal(0);
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/image_popup`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNews(datas.data);
            });
    }, []);

    return (
        <div className="bg-white">
            <NavbarTop />
            <NavbarBottom />
            <Product />
            <GalleryVideo />
            {/*<HomeNews />*/}
            <CategoriesProduct />
            <Bidang />
            <Clproduct />
            <LinkTerkait />
            <Tautan />
            <Gallery />
            <Agenda />
            <Ebooklist />
            <Info />
            <Grafik />

            {newsList.map((data_news, indexnews_list) => (
                <>
                    {data_news?.status == 1 ?
                    <>
                            {openModal == 1 ? <>
                                <div class="relative z-1" aria-labelledby="modal-title" role="dialog" aria-modal="true">

                                    <div class="fixed inset-0 bg-gray-500/75 transition-opacity" aria-hidden="true"></div>

                                    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                                        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

                                            <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                                <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                                    {/*<div class="sm:flex sm:items-start">
                                                        <div class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 3.03v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.49l-.51.766a2.25 2.25 0 0 1-1.161.886l-.143.048a1.107 1.107 0 0 0-.57 1.664c.369.555.169 1.307-.427 1.605L9 13.125l.423 1.059a.956.956 0 0 1-1.652.928l-.679-.906a1.125 1.125 0 0 0-1.906.172L4.5 15.75l-.612.153M12.75 3.031a9 9 0 0 0-8.862 12.872M12.75 3.031a9 9 0 0 1 6.69 14.036m0 0-.177-.529A2.25 2.25 0 0 0 17.128 15H16.5l-.324-.324a1.453 1.453 0 0 0-2.328.377l-.036.073a1.586 1.586 0 0 1-.982.816l-.99.282c-.55.157-.894.702-.8 1.267l.073.438c.08.474.49.821.97.821.846 0 1.598.542 1.865 1.345l.215.643m5.276-3.67a9.012 9.012 0 0 1-5.276 3.67m0 0a9 9 0 0 1-10.275-4.835M15.75 9c0 .896-.393 1.7-1.016 2.25" />
                                                            </svg>
                                                        </div>
                                                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                                            Selamat Datang di Website JDIH Kota Magelang
                                                        </div>
                                                    </div>*/}<br />
                                                    <PopupImage />
                                                </div>
                                                <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                    <button type="button" onClick={modalSetClose} class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto">Close</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </> : ""}
                    </> 
                    :
                    ''
                   }            
                </>
            ))}     
        </div>
    );
}

export default Home;
